import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL CATEGORIES SERVICE
export const getCategriesService = createAsyncThunk(
  "categories/getCategriesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.categoriesURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE TRAINER SERVICE
export const cretateCategoryService = createAsyncThunk(
  "categories/cretateCategoryService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.categoriesURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE TRAINER SERVICE
export const deleteCategoryService = createAsyncThunk(
  "categories/deleteCategoryService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.categoriesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE TRAINER SERVICE
export const updateCategoryService = createAsyncThunk(
  "categories/updateCategoryService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.categoriesURL}/${params?.id}`,
        params.formData
      , {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET CATEGORY BY ID SERVICE
export const getCategoryByIdService = createAsyncThunk(
  "categories/getCategoryByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.categoriesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
